import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { getValueFromUrl } from './eventTracker';

let gaTrackingID;
let isDebug = false;

switch (window.location.hostname) {
  case 'infosight.hpe.com': {
    gaTrackingID = 'UA-128581177-1';
    break;
  }
  case 'beta.infosight.hpe.com': {
    gaTrackingID = 'UA-128581177-3';
    break;
  }
  case 'dev.infosight.hpe.com': {
    gaTrackingID = 'UA-128581177-2';
    break;
  }
  default: {
    gaTrackingID = 'UA-128581177-2';
    isDebug = true;
    break;
  }
}
ReactGA.initialize(gaTrackingID, {
  debug: isDebug,
});

export const withTracker = (WrappedComponent, options = {}) => {
  let isTrackPage = true;
  let _location = window.location;
  if (typeof _location !== 'undefined') {
    const model = getValueFromUrl({
      location: _location,
      fieldName: 'model',
    });
    isTrackPage = !!model;
  }

  const trackPage = page => {
    if (isTrackPage) {
      ReactGA.set({
        page,
        ...options,
      });
      ReactGA.pageview(page);
    }
  };

  // eslint-disable-next-line
  const HOC = class extends Component {
    componentDidMount() {
      // eslint-disable-next-line
      const page = this.props.location.pathname + this.props.location.search;
      trackPage(page);
    }

    componentDidUpdate(prevProps) {
      const currentPage = prevProps.location.pathname + prevProps.location.search;
      const nextPage = this.props.location.pathname + this.props.location.search;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      const params = { ...this.props, ...options };
      return <WrappedComponent {...params} />;
    }
  };

  return HOC;
};
